import API from "../../api/API";

// import { Dialog } from "@mui/material";

import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useRef, useState } from "react";
import { ImovelType, SafraType, STATUS } from "../../db/Orm";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

type PropsCadastro = {
    show: boolean
    setShow: Function
    propriedades: ImovelType[]
    safras: SafraType[]
    onSuccess: () => void;
}

const CadastroAntecipacao = (props: PropsCadastro) => {
    const [imovel, setImovel] = useState<ImovelType | null>(null)
    const [safra, setSafra] = useState<SafraType | null>(props.safras.length>0? props.safras[props.safras.length-1]:null)
    const toast = useRef<Toast | null>(null)
    // const [imoveis, setImoveis] = useState<ImovelType[]>()
    const handleCreateAntecipacao = async () => {
        if (!imovel || !safra) {
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Selecione uma propriedade e uma safra para criar a antecipação.', life: 3000 });
            }
            return;
        }

        try {
            await API.criarPlano(imovel.id, safra.id);
            setImovel(null); // Clear selection after creation
            setSafra(null); // Safra is now fixed, no need to clear
            props.setShow(false);
            props.onSuccess();
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao criar antecipação.', life: 3000 });
            }
        }
    };
    return <Dialog header={'Nova Antecipação'} visible={props.show} onHide={() => props.setShow(false)}>
        <Toast ref={toast} />
        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'end'}}>
            <div style={{ marginRight: '10px' }}>
                <label htmlFor="propriedadeDropdown" style={{ display: 'block', marginBottom: '5px' }}>Imóvel</label>
                <Dropdown
                    id="propriedadeDropdown"
                    value={imovel}
                    options={props.propriedades.filter((p: ImovelType) => p.status === STATUS.APROVADO)}
                    onChange={(e) => setImovel(e.value)}
                    optionLabel="nome"
                    placeholder="Selecione uma Propriedade"
                    style={{ width: '200px' }}
                />
            </div>
            <div style={{ marginRight: '10px' }}>
                <label htmlFor="safraDropdown" style={{ display: 'block', marginBottom: '5px' }}>Safra</label>
                <Dropdown
                    id="safraDropdown"
                    value={safra}
                    options={props.safras}
                    onChange={(e) => setSafra(e.value)}
                    placeholder="Selecione a Safra"
                    style={{ width: '170px' }}
                    optionLabel='periodo'
                    // disabled={true} // Set to true to make it disabled
                />
            </div>

            <div style={{ marginLeft: 'auto' }}>
                <Button label="Criar" icon="pi pi-plus" onClick={handleCreateAntecipacao} />
            </div>
        </div>
    </Dialog>
}
export default CadastroAntecipacao;